import Constants from '@/Constants';
import Category, { CategoryTranslation } from '@/models/Category';
import http from '@/services/HttpService';

interface GetCategoryExistsByTranslationNameParams {
    translations: CategoryTranslation[];
    applicationId: number;
    organizationId: number;
}

export async function getCategoryExistsByTranslationName({
    applicationId,
    organizationId,
    translations,
}: GetCategoryExistsByTranslationNameParams): Promise<Category | undefined> {
    try {
        let categoryFound: Category | undefined;

        for (const translation of translations) {
            if (!categoryFound) {
                const { data } = await http.get<Category[]>(`${Constants.CATEGORIES_URI}`, {
                    params: {
                        applicationId,
                        organizationId,
                        name: translation.name,
                        locale: translation.locale,
                        withExactName: true,
                    },
                });

                if (data && data.length === 1) {
                    return data[0];
                }
            }
        }
    } catch (error) {
        return undefined;
    }
}
